import React from 'react'

import { Box, DisplayPosition, withCitrusTheme } from '@gousto-internal/citrus-react'

const SoldOutOverlayMask = withCitrusTheme(Box, (theme) => ({
  inset: 0,
  backgroundColor: theme.tokens.colors.White,
  opacity: 0.7,
  zIndex: 3,
}))

type SoldOutOverlayProps = {
  isOutOfStock: boolean
}

export const SoldOutOverlay = ({ isOutOfStock }: SoldOutOverlayProps) => {
  if (!isOutOfStock) {
    return null
  }

  return (
    <SoldOutOverlayMask
      data-testid="recipe-tile-sold-out-overlay"
      position={DisplayPosition.Absolute}
    />
  )
}
